import { render, staticRenderFns } from "./vlogdetail.vue?vue&type=template&id=4ec5c7e0&scoped=true&"
import script from "./vlogdetail.vue?vue&type=script&lang=js&"
export * from "./vlogdetail.vue?vue&type=script&lang=js&"
import style0 from "./vlogdetail.vue?vue&type=style&index=0&id=4ec5c7e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec5c7e0",
  null
  
)

export default component.exports